import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthComponentModel } from 'app/modules/common/entities/AuthComponentModel';
import { TaskSaveService } from '../../../task/services/task-save.service';
import { DoctorService } from '../../../doctor/services/doctor.service';
import { requiredValidator } from '../../validation/common-validation';
import { CreateLeaveService } from 'app/modules/employee-view/services/create-leave.service';
import Utils from 'app/Utils';

type AuthorType = 'G' | 'M' | 'C' | 'U' | 'E';

type AuthorDropdownValue = {
    order: number;
    value: AuthorType;
    viewValue: AuthorViewValue;
};

export type AuthorViewValue =
    | 'Yo'
    | 'Médico asignado'
    | 'Administrativo asignado'
    | 'Coordinador asignado'
    | 'Otro usuario'
    | 'Otro médico'
    | 'Otro coordinador'
    | 'La empresa'
    | 'La mutua';

@Component({
    selector: 'app-author',
    templateUrl: './author.component.html',
    styleUrls: ['./author.component.scss'],
    standalone: false
})
export class AuthorComponent implements OnInit {
    @Input() authorFormGroup: UntypedFormGroup;
    @Input() tipoAutor: any;
    @Input() authComponentModel: AuthComponentModel;
    authorList: AuthorDropdownValue[] = [];
    userList: any = [];
    medicoList: any = [];
    coordinatorList: any = [];
    currentUser: any;

    loggedUserTipoAutor: AuthorType;
    deftareaTipoAutor: string;
    authCompModel: AuthComponentModel = new AuthComponentModel();

    dropDownActivate = {
        user: false,
        coordinador: false,
        doctor: false,
    };

    constructor(
        public taskService: TaskSaveService,
        private doctorService: DoctorService,
        private createLeaveService: CreateLeaveService
    ) {
        this.createLeaveService.leaveDoctrId.subscribe((res) => {
            this.updateAssignedMedicoForNewLeave(res);
        });
    }

    ngOnInit(): void {
        // add the more robust author type controller
        // changes in this controller will be reflected in original old author type controller
        // special thing about this is, that this controller does not have duplicate values
        if (!this.authorFormGroup.get('robutsAuthorType')) {
            this.authorFormGroup.addControl(
                'robutsAuthorType',
                new UntypedFormControl(null, Validators.required)
            );
        }

        // listen for changes in robuts author type controller
        this.authorFormGroup
            .get('robutsAuthorType')
            .valueChanges.subscribe((v) => {
                this.onRobustAuthorTypeChanges(v);
            });

        this.authorFormGroup.controls.Tipo.valueChanges.subscribe((res) => {
            // get selected author
            const selectedAuthor = this.authorList.filter(
                (x: { value: any }) => x.value === res
            )[0];
            if (selectedAuthor)
                this.changeAuthor(
                    selectedAuthor.viewValue,
                    selectedAuthor.value
                );
        });

        // if author type already has a value, raise the change event
        if (this.authorFormGroup.controls.robutsAuthorType.value) {
            this.onRobustAuthorTypeChanges(
                this.authorFormGroup.controls.robutsAuthorType.value
            );
        }
    }

    ngOnChanges(): void {
        this.ititializeData();
    }

    private onRobustAuthorTypeChanges(value: AuthorViewValue) {
        const tipo = this.authorList.find((x) => x.viewValue === value)?.value;
        this.authorFormGroup.get('Tipo').setValue(tipo);
        this.authorFormGroup.updateValueAndValidity();
        this.OnAuthorChange({
            source: { selected: { viewValue: value } },
            value: tipo,
        });
    }

    ititializeData(): void {
        this.deftareaTipoAutor = this.tipoAutor;
        this.authCompModel = this.authComponentModel;
        this.getLoggedUseTipoAutor();
        this.LoadAuthorList();
    }

    LoadAuthorList(): void {
        this.authorList = [
            { order: 1, value: this.loggedUserTipoAutor, viewValue: 'Yo' },
            { order: 2, value: `M`, viewValue: 'Médico asignado' },
            { order: 3, value: `G`, viewValue: 'Administrativo asignado' },
            { order: 4, value: `C`, viewValue: 'Coordinador asignado' },
            { order: 5, value: `G`, viewValue: 'Otro usuario' },
            { order: 6, value: `M`, viewValue: 'Otro médico' },
            { order: 7, value: `C`, viewValue: 'Otro coordinador' },
            { order: 8, value: `E`, viewValue: 'La empresa' },
            { order: 9, value: `U`, viewValue: 'La mutua' },
        ];

        let selectedIndex = 0;

        if (!this.authCompModel.medicoId) {
            selectedIndex = this.authorList
                .map(function (e) {
                    return e.order;
                })
                .indexOf(2);
            this.authorList.splice(selectedIndex, 1);
        }
        if (!this.authCompModel.administrativa) {
            selectedIndex = this.authorList
                .map(function (e) {
                    return e.order;
                })
                .indexOf(3);
            this.authorList.splice(selectedIndex, 1);
        }
        if (!this.authCompModel.coordinador) {
            selectedIndex = this.authorList
                .map(function (e) {
                    return e.order;
                })
                .indexOf(4);
            this.authorList.splice(selectedIndex, 1);
        }

        this.SetAuthorDropdownValueWithParameter(this.deftareaTipoAutor);
        const taskType: AuthorType = this.authorFormGroup.get('Tipo').value;
        const viewValue = this.authorList.filter((x) => x.value == taskType)[0]
            ?.viewValue;
        this.setOtherDropdownValueForAutorDropdownChange(
            taskType === 'G' && viewValue === 'Otro usuario',
            taskType === 'M' && viewValue === 'Otro médico',
            taskType === 'C' && viewValue === 'Otro coordinador'
        );
    }

    SetAuthorDropdownValueWithParameter(tipoAutor: any): void {
        const tempList = [];
        tempList.push(this.authorList[0]);
        this.authorList = this.authorList.slice(1, this.authorList.length);

        if(tipoAutor)
        {
            for (let i = 0; i < tipoAutor.length; i++) {
                const s = tipoAutor.charAt(i);
                if (tipoAutor.toUpperCase().indexOf(s) !== -1) {
                    const tempListX = this.authorList.filter(
                        (x) => x.value.indexOf(s) !== -1
                    );
                    tempListX.forEach((ele) => {
                        tempList.push(ele);
                    });
                }
            }
    
            const tempListX1 = this.authorList.filter(
                (x) => x.value.indexOf('E') !== -1
            );
            tempListX1.forEach((ele) => {
                tempList.push(ele);
            });
    
            const tempListX2 = this.authorList.filter(
                (x) => x.value.indexOf('U') !== -1
            );
            tempListX2.forEach((ele) => {
                tempList.push(ele);
            });
    
            this.authorList = tempList;
            this.authorList = this.authorList.sort((a, b) => a.order - b.order);
        }
        
    }

    getLoggedUseTipoAutor(): void {
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (this.currentUser.medicoId != null) {
            this.loggedUserTipoAutor = 'M';
        } else if (this.currentUser.coordinador != null) {
            this.loggedUserTipoAutor = 'C';
        } else {
            this.loggedUserTipoAutor = 'G';
        }
    }

    OnAuthorChange(event: {
        source: { selected: { viewValue: string } };
        value: string;
    }): void {
        if (event) {
            this.changeAuthor(event.source.selected.viewValue, event.value);
        }
    }

    private changeAuthor(viewValue: string, value: string): void {
        const selectedViewValue = viewValue;
        switch (selectedViewValue) {
            case 'Yo': {
                this.setFormGroupControlValuesForCurrentUser(value);
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    false
                );
                break;
            }
            case 'Médico asignado': {
                this.setFormGroupControlValuesForOtherUser(
                    this.authCompModel.medicoNombre,
                    this.authCompModel.medicoId
                );
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    false
                );
                break;
            }
            case 'Administrativo asignado': {
                this.setFormGroupControlValuesForOtherUser(
                    this.authCompModel.usuarioAbreviacion,
                    null
                );
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    false
                );
                break;
            }
            case 'Coordinador asignado': {
                this.setFormGroupControlValuesForOtherUser(
                    this.authCompModel.coordinatorNombre,
                    null
                );
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    false
                );
                break;
            }
            case 'Otro usuario': {
                this.LoadUserDropdownList();
                this.setOtherDropdownValueForAutorDropdownChange(
                    true,
                    false,
                    false
                );
                break;
            }
            case 'Otro médico': {
                this.LoadMedicoDropdownList();
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    true,
                    false
                );
                break;
            }
            case 'Otro coordinador': {
                this.LoadCoordinatorDropdownList();
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    true
                );
                break;
            }
            case 'La empresa': {
                this.setFormGroupControlValuesForOtherUser('EMPRESA', null);
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    false
                );
                break;
            }
            case 'La mutua': {
                this.setFormGroupControlValuesForOtherUser('MUTUA', null);
                this.setOtherDropdownValueForAutorDropdownChange(
                    false,
                    false,
                    false
                );
                break;
            }
        }
    }

    LoadUserDropdownList(): void {
        this.taskService.GetUsersAbreviacion().subscribe((res) => {
            if (res) {
                this.userList = res.result;
            }
        });
    }

    LoadMedicoDropdownList(): void {
        this.doctorService.GetActiveDoctorsDropdown().subscribe((res) => {
            if (res) {
                this.medicoList = res;
            }
        });
    }

    LoadCoordinatorDropdownList(): void {
        this.taskService.GetActiveCoordinator().subscribe((res) => {
            if (res) {
                this.coordinatorList = res.result;
            }
        });
    }

    setFormGroupControlValuesForCurrentUser(tipo: string): void {
        switch (tipo) {
            case 'C':
                this.setFormGroupControlValuesForOtherUser(
                    this.currentUser.coordinador,
                    null
                );
                break;
            case 'M':
                this.getCurrentUserDoctor();
                break;
            case 'G':
                this.setFormGroupControlValuesForOtherUser(
                    this.currentUser.abreviacion,
                    null
                );
                break;
        }
    }

    public getCurrentUserDoctor(): void {
        this.doctorService
            .GetDoctor(this.currentUser.medicoId)
            .subscribe((res) => {
                if (res && res.result) {
                    this.setFormGroupControlValuesForOtherUser(
                        res.result.nombre,
                        this.currentUser.medicoId
                    );
                }
            });
    }

    setOtherDropdownValueForAutorDropdownChange(
        isUser,
        isDoctor,
        isCoordinator
    ): void {
        this.dropDownActivate.user = isUser;
        this.dropDownActivate.doctor = isDoctor;
        this.dropDownActivate.coordinador = isCoordinator;
        if (isUser) {
            this.authorFormGroup
                .get('Usuario')
                .setValidators(requiredValidator());
        } else {
            this.authorFormGroup.get('Usuario').setValidators(null);
            this.authorFormGroup.get('Usuario').patchValue(null);
        }
        if (isCoordinator) {
            this.authorFormGroup
                .get('Coordinator')
                .setValidators(requiredValidator());
        } else {
            this.authorFormGroup.get('Coordinator').setValidators(null);
            this.authorFormGroup.get('Coordinator').patchValue(null);
        }
        if (isDoctor) {
            this.authorFormGroup
                .get('Medico')
                .setValidators(requiredValidator());
        } else {
            this.authorFormGroup.get('Medico').setValidators(null);
            this.authorFormGroup.get('Medico').patchValue(null);
        }
        this.authorFormGroup.updateValueAndValidity();
    }

    setFormGroupControlValuesForOtherUser(nombre: string, medicoId: any): void {
        this.authorFormGroup.get('Nombre').patchValue(nombre);
        this.authorFormGroup.get('MedicoId').patchValue(medicoId);
    }

    OnUserChange(event): void {
        const selectedvalue =
            this.authorFormGroup.get('Tipo').value === 'M' ? event.value : null;
        const selectedSource = event.source.selected;
        const selectedViewValue =
            this.authorFormGroup.get('Tipo').value === 'G'
                ? this.userList.filter((e) => e.value === event.value)[0]
                      .stringValue
                : selectedSource.viewValue;
        this.setFormGroupControlValuesForOtherUser(
            selectedViewValue,
            selectedvalue
        );
    }

    public updateAssignedMedicoForNewLeave(doctorId: number): void {
        const listItem = this.authorList.filter((e) => e.order === 2)[0];
        this.authCompModel.medicoId = doctorId;

        if (!listItem) {
            const item: AuthorDropdownValue = {
                order: 2,
                value: `M`,
                viewValue: 'Médico asignado',
            };
            this.authorList.splice(1, 0, item);
        }
    }
}
